import { call, put } from "redux-saga/effects";

import DossierActions from "../redux/DossierRedux";

// process STARTUP actions
export function* getDossier(api, { id }) {
  // make the call to the api
  const response = yield call(api.getDossier, id);

  if (response.ok) {
    response.data.id = id;
    yield put(DossierActions.dossierSuccess(response.data));
  } else {
    yield put(DossierActions.dossierFailure());
  }
}

export function* saveDossier(api, { dossier }) {
  // make the call to the api
  const response = yield call(api.saveDossier, dossier);

  if (response.ok) {
    yield put(DossierActions.dossierSuccess(response.data));
  } else {
    yield put(DossierActions.dossierFailure());
  }
}
